'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import { ListItem } from '@/shared/ui/DropdownMenu/types';
import { DropdownMenuContent, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuRoot, DropdownMenuSeparator, DropdownMenuTrigger } from '@ncai-axe/react-ui-v3';
import SearchIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_search.svg';
import { useTranslations } from 'next-intl';
import styles from './style.module.scss';
import DropdownTrigger from '../DropdownTrigger';
import SelectListItem from './SelectListItem';
type DropdownProps = {
  items: (ListItem & {
    value: string;
  })[];
  defaultItem: ListItem;
  value: string | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  showCheckIcon?: boolean;
  contentWidth?: string;
  triggerButtonSize?: 'small' | 'medium' | 'large';
  maxHeight?: string;
  searchable?: boolean;
  searchPlaceholder?: string;
  onOpenChange?: (open: boolean) => void;
  /**
   * true 면 dropdown content 가 trigger 의 실제 width 를 따른다.
   * portal 안의 'width: 100%' 는 부모 ref 가 portal 컨테이너라 의도와 다르므로,
   * radix popper 가 expose 하는 anchor width 변수를 사용한다.
   */
  matchTriggerWidth?: boolean;
};
export default function SelectDropdown(t0) {
  const $ = _c(45);
  const {
    items,
    defaultItem,
    value,
    onChange,
    disabled: t1,
    showCheckIcon: t2,
    contentWidth: t3,
    triggerButtonSize: t4,
    maxHeight,
    searchable: t5,
    searchPlaceholder,
    onOpenChange,
    matchTriggerWidth: t6
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const showCheckIcon = t2 === undefined ? true : t2;
  const contentWidth = t3 === undefined ? "263px" : t3;
  const triggerButtonSize = t4 === undefined ? "small" : t4;
  const searchable = t5 === undefined ? false : t5;
  const matchTriggerWidth = t6 === undefined ? false : t6;
  const t = useTranslations("common");
  let t7;
  if ($[0] !== searchPlaceholder || $[1] !== t) {
    t7 = searchPlaceholder ?? t("placeholder.search");
    $[0] = searchPlaceholder;
    $[1] = t;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const resolvedSearchPlaceholder = t7;
  const isDisabled = disabled || items.length === 0;
  const [search, setSearch] = useState("");
  let t8;
  if ($[3] !== defaultItem || $[4] !== items || $[5] !== value) {
    t8 = items.find(item => item.value === value) ?? defaultItem;
    $[3] = defaultItem;
    $[4] = items;
    $[5] = value;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const selectItem = t8;
  let t9;
  bb0: {
    if (!searchable || !search.trim()) {
      t9 = items;
      break bb0;
    }
    let t10;
    if ($[7] !== items || $[8] !== search) {
      const keyword = search.trim().toLowerCase();
      t10 = items.filter(item_0 => (item_0.label ?? "").toLowerCase().includes(keyword));
      $[7] = items;
      $[8] = search;
      $[9] = t10;
    } else {
      t10 = $[9];
    }
    t9 = t10;
  }
  const filteredItems = t9;
  let t10;
  if ($[10] !== onChange) {
    t10 = value_0 => {
      onChange(value_0);
    };
    $[10] = onChange;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const handleChange = t10;
  let t11;
  if ($[12] !== onOpenChange) {
    t11 = open => {
      if (!open) {
        setSearch("");
      }
      onOpenChange?.(open);
    };
    $[12] = onOpenChange;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const handleOpenChange = t11;
  let t12;
  if ($[14] !== contentWidth) {
    t12 = {
      width: contentWidth
    };
    $[14] = contentWidth;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== selectItem.caption || $[17] !== selectItem.label || $[18] !== selectItem.leadingIcon) {
    t13 = <DropdownTrigger.Content label={selectItem.label} caption={selectItem.caption} leadingIcon={selectItem.leadingIcon} />;
    $[16] = selectItem.caption;
    $[17] = selectItem.label;
    $[18] = selectItem.leadingIcon;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== isDisabled || $[21] !== t12 || $[22] !== t13 || $[23] !== triggerButtonSize) {
    t14 = <DropdownTrigger.Button className={styles.dropdownTrigger} disabled={isDisabled} size={triggerButtonSize} style={t12}>{t13}</DropdownTrigger.Button>;
    $[20] = isDisabled;
    $[21] = t12;
    $[22] = t13;
    $[23] = triggerButtonSize;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== isDisabled || $[26] !== t14) {
    t15 = <DropdownMenuTrigger asChild={true} disabled={isDisabled}>{t14}</DropdownMenuTrigger>;
    $[25] = isDisabled;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== contentWidth || $[29] !== filteredItems || $[30] !== handleChange || $[31] !== isDisabled || $[32] !== items.length || $[33] !== matchTriggerWidth || $[34] !== maxHeight || $[35] !== resolvedSearchPlaceholder || $[36] !== search || $[37] !== searchable || $[38] !== showCheckIcon || $[39] !== value) {
    t16 = items.length > 0 && !isDisabled && <DropdownMenuPortal><DropdownMenuContent side="bottom" className={styles.dropdown} style={{
        width: matchTriggerWidth ? "var(--radix-popper-anchor-width)" : contentWidth,
        maxHeight: maxHeight ?? "auto"
      }}>{searchable && <><div className={styles.searchWrapper}><div className={styles.searchInputContainer}><SearchIcon className={styles.searchIcon} width={16} height={16} /><input className={styles.searchInput} type="text" placeholder={resolvedSearchPlaceholder} value={search} onChange={e => setSearch(e.target.value)} onKeyDown={_temp} /></div></div><DropdownMenuSeparator className={styles.searchSeparator} /></>}<DropdownMenuRadioGroup value={value} onValueChange={handleChange} className={styles.dropdownRadioGroup}>{filteredItems.map(item_1 => <DropdownMenuRadioItem key={item_1.value} value={item_1.value} showCheckIcon={showCheckIcon} disabled={item_1.disabled}><SelectListItem label={item_1.label} labelStyle={item_1.labelStyle} caption={item_1.caption} leadingIcon={item_1.leadingIcon} /></DropdownMenuRadioItem>)}</DropdownMenuRadioGroup></DropdownMenuContent></DropdownMenuPortal>;
    $[28] = contentWidth;
    $[29] = filteredItems;
    $[30] = handleChange;
    $[31] = isDisabled;
    $[32] = items.length;
    $[33] = matchTriggerWidth;
    $[34] = maxHeight;
    $[35] = resolvedSearchPlaceholder;
    $[36] = search;
    $[37] = searchable;
    $[38] = showCheckIcon;
    $[39] = value;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== handleOpenChange || $[42] !== t15 || $[43] !== t16) {
    t17 = <DropdownMenuRoot onOpenChange={handleOpenChange}>{t15}{t16}</DropdownMenuRoot>;
    $[41] = handleOpenChange;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  return t17;
}
function _temp(e_0) {
  return e_0.stopPropagation();
}